import * as React from "react";
const ButtonPlayIcon = (props) => (
  <svg
    width={17}
    height={20}
    viewBox="0 0 17 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 10V1.69951C0 0.93703 0.819112 0.455062 1.48564 0.825357L9 5L16.4265 9.12584C17.1123 9.50685 17.1123 10.4932 16.4265 10.8742L9 15L1.48564 19.1746C0.819112 19.5449 0 19.063 0 18.3005V10Z"
      fill="white"
    />
  </svg>
);
export default ButtonPlayIcon;
